import Swal from 'sweetalert2'
import store from '@/store'

const EXAM_SELECTION_STEP_ID = 'exam-selection'
const FLOW_STEP_WHITELIST = [
  'oop-selection',
  'info',
  'add-ons',
  'extra-info',
  'notice',
  'date-selection',
  'time-selection',
  'registrant-gate',
  'user-notes',
  'confirmation',
  'customer-service',
]

function isExamSelectionStepRoute(to) {
  return to.name === 'TongxinStep' && to.params.stepId === EXAM_SELECTION_STEP_ID
}

function hasRequiredEntryQuery(to) {
  return Boolean(to.query.clinicCode) && Boolean(to.query.sourceType)
}

function isEntryExamSelectionRoute(to, from) {
  // 當登入後透過 location.href & redirect_uri 進行重新導向時，且位於第一頁（沒有 categoryId），視為入口
  if (from.name === null && !to.params.categoryId && to.name === 'TongxinStep') {
    return true
  }

  if (!isExamSelectionStepRoute(to)) {
    return false
  }

  // 第一頁：/step/exam-selection?clinicCode=...&sourceType=...
  // 第二、三頁會帶 categoryId，不視為入口
  if (to.params.categoryId) {
    return false
  }

  return hasRequiredEntryQuery(to)
}

function isReadOnlyInfoRoute(to) {
  return to.name === 'TongxinStep'
    && to.params.stepId === 'info'
    && to.query.readonlyInfo === '1'
}

function shouldCheckFlowReload(to) {
  if (to.name === 'TongxinFamilySelection') {
    return true
  }

  if (to.name === 'TongxinFamilyMeAdd') {
    return true
  }

  if (to.name !== 'TongxinStep') {
    return false
  }

  // 第二、三頁：/step/exam-selection/:categoryId 也需要檢查
  if (to.params.stepId === EXAM_SELECTION_STEP_ID && to.params.categoryId) {
    return true
  }

  return FLOW_STEP_WHITELIST.includes(to.params.stepId)
}

function buildRedirectQueryFromSession() {
  const clinicCode = store.getters['web/tongxin/clinicCode']
  const sourceType = store.getters['web/tongxin/sourceType']
  const isGuest = store.getters['web/tongxin/isGuest']

  if (!clinicCode || !sourceType) {
    return null
  }

  const query = {
    clinicCode: clinicCode,
    sourceType: sourceType,
  }

  if (isGuest) {
    query.from = 'web'
  }

  return query
}

export default async function tongxinFlowGuard({ next, to, from }) {
  if (isEntryExamSelectionRoute(to, from)) {
    store.dispatch('web/tongxin/setFlowAlive', true)
    return next()
  }

  // 唯讀 info（只顯示返回）為流程終點之一，reload 不強制導回第一頁
  if (isReadOnlyInfoRoute(to)) {
    return next()
  }

  if (!shouldCheckFlowReload(to)) {
    return next()
  }

  const isFlowAlive = store.getters['web/tongxin/flowAlive']
  const redirectQuery = buildRedirectQueryFromSession()

  if (isFlowAlive || !redirectQuery) {
    return next()
  }

  await Swal.fire({
    type: 'warning',
    title: '頁面已重新整理',
    text: '由於網頁重整，為確保您的使用體驗，我們將帶您回到起始頁。請稍候片刻...',
    confirmButtonText: '確認',
    allowOutsideClick: false,
    allowEscapeKey: false,
  })

  return next({
    name: 'TongxinStep',
    params: {
      org_code: to.params.org_code,
      stepId: EXAM_SELECTION_STEP_ID,
    },
    query: redirectQuery,
    replace: true,
  })
}
